import React, {useState} from 'react';
import RecommendedCancelMessage from "../messages/RecommendedCancelMessage";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";
import {toast} from "react-toastify";
import {ERROR_STATUS} from "../../../status/status";
import {mutate} from "swr";
import useResponsive from "../../../components/hooks/useResponsive";
import ThreeDotsLoading from "../../../components/loader/ThreeDotsLoading";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {COLORS} from "../../../ui/Theme";
import Loading from "../../../components/loader/Loading";

const RecommendedSettingFormButton = () => {

    const {
        config,
        tableData,
        configData,
        editedName,
        updateConfig,
    } = useRecommendedContext();

    const {isMd} = useResponsive();

    const [openCancelModal, setOpenCancelModal] = useState(false);
    const handleOpenCancelModal = () => setOpenCancelModal(true);
    const handleCloseCancelModal = () => setOpenCancelModal(false);

    const handleSaveSettings = async () => {
        if (!editedName.trim()) {
            toast.error(ERROR_STATUS.INCOMPLETE);
            return;
        }

        const updatedConfigList = configData.configList.map((config) =>
            config.is_default ? {...config, name: editedName.trim()} : config
        );

        const payload = {
            config_list: updatedConfigList,
            default_config: configData.defaultConfig,
        };

        updateConfig(payload);

        await Promise.all([
            mutate("/stock-market/recommended"),
            mutate("/stock-market/v2/recomm-config"),
        ]);
    };

    return (
        <>
            <button
                disabled={config.isValidating}
                className="btn btn-blue"
                onClick={handleSaveSettings}
                style={{width: isMd ? "150px" : "100%", padding: "13px 32px"}}
            >
                {
                    config.isValidating
                        ?
                        <Loading
                            size="11px"
                            color={COLORS.WHITE}
                        />
                        :
                        <>
                            ذخیره تنظیمات
                        </>
                }
            </button>
            <button
                onClick={handleOpenCancelModal}
                className="btn btn-softred"
                style={{width: isMd ? "110px" : "100%", padding: "13px 32px"}}
            >
                انصراف
            </button>
            <RecommendedCancelMessage
                openCancelModal={openCancelModal}
                handleCloseCancelModal={handleCloseCancelModal}
            />
        </>
    );
};

export default RecommendedSettingFormButton;